import { ChatBubbleLeftEllipsisIcon } from "@heroicons/react/24/outline";

import { Button } from "@fronterahealth/frontera-ui-components/ui/button";

import { ReviewItemFieldsFragment } from "@api/graphql/types-and-hooks";
import { CommentActionTooltip } from "@components/QaReview/components/CommentActionTooltip";
import { useReviewData } from "@components/QaReview/hooks/useReviewData";
import { useReviewSession } from "@components/QaReview/hooks/useReviewSession";

interface CommentActionRepliesProps {
  comment: ReviewItemFieldsFragment;
  onActivate?: () => void;
}

export const CommentActionReplies: React.FC<CommentActionRepliesProps> = ({ comment, onActivate }) => {
  const { repliesByParentId } = useReviewData();
  const { state, dispatch } = useReviewSession();
  const repliesCount = repliesByParentId.get(comment.id)?.length ?? 0;

  if (repliesCount === 0) return <span />;

  const collapsedLabel = `${repliesCount} ${repliesCount === 1 ? "reply" : "replies"}`;
  const expanded = state.expandedReplies.includes(comment.id);

  return (
    <CommentActionTooltip
      label={expanded ? "Collapse the replies under this comment" : "Show the replies under this comment"}
    >
      <Button
        variant="ghost"
        size="xs"
        onClick={() => {
          dispatch({ type: "toggleReplies", rootId: comment.id });
          onActivate?.();
        }}
      >
        <ChatBubbleLeftEllipsisIcon className="h-3.5 w-3.5" />
        {expanded ? "Hide replies" : collapsedLabel}
      </Button>
    </CommentActionTooltip>
  );
};
